// client/src/services/apiClient.ts
import axios from "axios";

const apiClient = axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    timeout: 30000,
});

/* ===========================
   STEP 2: AUTH INTERCEPTOR
   =========================== */
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers = config.headers ?? {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/* ===========================
   STEP 3: ERROR INTERCEPTOR
   =========================== */
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        const message =
            error?.response?.data?.message ||
            error?.response?.data?.detail ||
            "Something went wrong";
        error.message = message;
        return Promise.reject(error);
    }
);

export default apiClient;
